import { createSlice } from '@reduxjs/toolkit';
import { fetchConsultantWebsiteList } from './features';

export const consultantWebsiteList = createSlice({
  name: 'consultantWebsiteList',
  initialState: {
    websites: null,
    isLoadingWebsites: false,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultantWebsiteList.fulfilled, (state, { payload }) => {
        state.websites = payload;
        state.isLoadingWebsites = false;
        state.isError = false;
      })
      .addCase(fetchConsultantWebsiteList.pending, (state) => {
        state.isLoadingWebsites = true;
        state.isError = false;
      })
      .addCase(fetchConsultantWebsiteList.rejected, (state) => {
        state.isLoadingWebsites = false;
        state.isError = true;
        if (state.websites === null) {
          state.websites = [];
        }
      });
  },
});

export default consultantWebsiteList.reducer;

export const consultantWebsiteListSelector = (state) => state.consultantWebsiteList;
